<template>
    <v-row no-gutters class="pa-1">
        <v-col cols="12">
            <v-tabs-window v-model="activeTab">
                <v-tabs-window-item value="TaxFormTable">
                    <v-row no-gutters>
                        <v-col cols="12" class="pa-2">
                            <TaxFormTable
                                ref="taxFormTable"
                                :tables="jsonForm"
                                :values="jsonValues"
                                :rules="jsonRules"
                                :sheet="sheet"
                                :isLoaded="loaded"
                                :enableEdition="enableEdition"
                                :fieldsChild="fieldsChild"
                                :isSent="isSent"
                                :readOnly="readOnly"
                                @updateSpecManager="updateSpecManager()"
                                @additionnal-page-created="additionnalPageCreated"
                            />
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
                <v-tabs-window-item value="TaxFormPng">
                    <v-row no-gutters>
                        <v-col cols="12" class="px-2">
                            <TaxFormPng
                                ref="taxFormPng"
                                :values="jsonValues"
                                :rules="jsonRules"
                                :cerfa="jsonCerfa"
                                :image="imageForm"
                                :isLoaded="loaded"
                                :enableEdition="enableEdition"
                                :sheet="sheet"
                                :fieldsChild="fieldsChild"
                                :readOnly="readOnly"
                                @updateSpecManager="updateSpecManager()"
                            />
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
            </v-tabs-window>
        </v-col>
    </v-row>
</template>
<script lang="ts">
import TaxFormTableComp, { TaxFormTable } from "./TaxFormTable.vue";
import TaxFormPngComp, { TaxFormPng } from "./TaxFormPng.vue";

import { SheetManager } from "../../../../backend/src/common/taxform/SheetManager";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";
import { Inject } from "vue-facing-decorator";

@Component({
    components: {
        TaxFormTable: TaxFormTableComp,
        TaxFormPng: TaxFormPngComp,
    },
    emits: ["allJson", "htmlToPrint", "svgToPrint"],
})
export class TaxForm extends Vue {
    @Prop({ default: null }) cerfaNumber: string;
    @Prop({ default: null }) year: string;
    @Prop({ default: null }) sheet: SheetManager;
    @Prop({ default: null }) fieldsChild: any;
    @Prop({ default: null }) formInput: any;
    @Prop({ default: null }) valuesInput: any;
    @Prop({ default: null }) rulesInput: any;
    @Prop({ default: null }) cerfaInput: any;
    @Prop({ default: null }) imageInput: any;
    @Prop({ default: null }) millesim: any;
    @Prop({ default: "TaxFormTable" }) activeTab: string;
    @Prop({ default: null }) initialValues: any;
    @Prop({ default: null }) loaded: any;
    @Prop({ default: false }) enableEdition: boolean;
    @Prop({ default: false }) isSent: boolean;
    @Prop({ default: false }) readOnly: boolean;

    @Ref() taxFormTable: TaxFormTable;
    @Ref() taxFormPng: TaxFormPng;

    @Inject({
        from: "taxFormFocusFromConsistencyCheck",
        default: "",
    })
    focusSpec: string;

    @Watch("focusSpec")
    checkFocusSpec() {
        if (this.cerfaNumber) {
            const [cerfaNumber, key] = this.focusSpec.split(":");
            if (cerfaNumber === this.cerfaNumber) {
                this.setFocus(key);
            }
        }
    }

    image = null;
    form: any = null;
    values: any = null;
    rules: any = null;
    cerfa: any = null;

    formId_ = null;

    get formId() {
        if (this.bundleManager) {
            return this.bundleManager.formId;
        }
        return this.formId_;
    }

    id = "";

    listFields = [];

    isChild = false;

    bundleManager: SheetManager = null;

    get jsonForm() {
        if (this.form) {
            return this.form.tables;
        }
        if (this.formInput) {
            return this.formInput.tables;
        }
        return null;
    }

    get jsonCerfa() {
        if (this.cerfa) {
            return this.cerfa;
        }
        if (this.cerfaInput) {
            return this.cerfaInput;
        }
        return null;
    }

    get jsonValues() {
        if (this.values) {
            return this.values;
        }
        if (this.valuesInput) {
            return this.valuesInput;
        }
        return null;
    }

    get jsonRules() {
        if (this.rules) {
            return this.rules;
        }
        if (this.rulesInput) {
            return this.rulesInput;
        }
        return null;
    }

    // Récupération de tous les json en 1 seul
    get allJson() {
        const all: any = {
            form: this.jsonForm,
            values: this.jsonValues,
            rules: this.jsonRules,
            cerfa: this.jsonCerfa,
            imageUrl: this.imageForm,
            id: this.formId,
        };
        this.$emit("allJson", all);
        return all;
    }

    get imageForm() {
        if (this.image) {
            return this.image;
        }
        if (this.imageInput) {
            return this.imageInput;
        }
        return null;
    }

    // Recup image et cerfa
    getImageCerfa() {
        if (this.jsonCerfa && this.image) {
            return {
                image: this.image,
                cerfa: this.jsonCerfa,
            };
        }
        return null;
    }

    setFocus(key: string) {
        // this.taxFormPng.setFocusedField(key)
        this.taxFormTable.setFocusedField(key);
    }

    @Emit("fieldUpdate")
    updateSpecManager() {
        // const BA_before_update = Spec.getValue(this.sheet.fields["BA"])
        // debugger
        this.sheet.update();
        // const BA_after_update = Spec.getValue(this.sheet.fields["BA"])
        // debugger
    }

    addExternalFields({ key, value }) {
        this.bundleManager.addExternalFields(key, value);
    }

    getValues() {
        if (this.bundleManager) {
            return this.bundleManager.getValues();
        }
        return [];
    }

    htmlToPrint(html) {
        this.$emit("htmlToPrint", html);
    }

    svgToPrint(svg) {
        this.$emit("svgToPrint", svg);
    }

    @Emit("additionnal-page-created")
    additionnalPageCreated(cerfaNumber: string) {
        return cerfaNumber;
    }
}

export default toNative(TaxForm);
</script>
